<div class="mb-16">
  <div class="chart-wrapper">
    <canvas #canvas width="1150" class="mx-auto"></canvas>
  </div>
</div>
